import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { UnderConstruction } from './pages/UnderConstruction';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3k7i474gb2026">
      <Routes data-id="element-1" data-mp="3fahxqsfjmvaj">
        <Route element={<Layout data-id="element-3" data-mp="3fbjbj4ny1vvy" />} data-id="element-2" data-mp="3f9yi5idd8izo">
          <Route path="/" element={<Home data-id="element-5" data-mp="3f8f2ntzjabyy" />} data-id="element-4" data-mp="3fb17hlv1iddh" />
          <Route path="*" element={<UnderConstruction data-id="element-7" data-mp="2rk4796clx4i2" />} data-id="element-6" data-mp="2rknoekufnov1" />
        </Route>
      </Routes>
    </BrowserRouter>;
}